import { breadCrumbList, breadCrumbListJson } from './config';

const ProjFn: any = {
  // 直播间跳转
  toStudioRoom(info: any) {
    // pathname: string,
    // roomId: number,
    // isCompetition?: number,
    // cateId?: number,
    // rank?: number,
    // keyword?: string,
    // collect?: string,
    // scene?: string
    let arrInfo: any[] = [];
    if (info.pathname) {
      arrInfo = breadCrumbList.filter((item: breadCrumbListJson) => {
        return item.value === info.pathname;
      });
    }
    return {
      path: '/newLive/studio',
      state: {
        ...info,
        type: arrInfo[0] ? arrInfo[0].id : info.type,
        scene: arrInfo[0] ? arrInfo[0].scene : info.scene
      }
    };
  },
  // 直播热度
  monryEllipsis: (item: any) => {
    let value = item;
    if (typeof item === 'string') {
      value = Number(value);
    }
    let unit: string = '';
    const k: number = 10000;
    const sizes: string[] = ['', '万', '亿', '万亿'];
    let i: number;
    if (value > k) {
      i = Math.floor(Math.log(value) / Math.log(k));
      value = parseFloat(String(value / Math.pow(k, i))).toFixed(1);
      unit = sizes[i];
    }
    return value + unit;
  },
  getCollectMark: (platform?: string): number => {
    return platform === '96show' ? 2 : 1;
  },
  // import liveFn from '@/views/NewLive/liveFn';
  // live_platform?: string;
  // live_platform: liveFn.getShowLivePlatform()
  // extends LivePlatFormJson
  setShowLivePlatform: (platform?: string) => {
    localStorage.setItem('LIVEROOM_PLATFORM', platform ?? '996box');
  },
  removeShowLivePlatform: () => {
    localStorage.removeItem('LIVEROOM_PLATFORM');
  },
  getShowLivePlatform: () => {
    const platform = localStorage.getItem('LIVEROOM_PLATFORM');
    return platform ?? '996box';
  },
  resolveShowLivePlatform: (platform?: string) => {
    return platform ?? ProjFn.getShowLivePlatform();
  }
};
export default ProjFn;
